// extracted by mini-css-extract-plugin
module.exports = {"Loading":"AboutUsPage_Loading__R_hip","ContainerBanner":"AboutUsPage_ContainerBanner__EAZSo","Banner":"AboutUsPage_Banner__65311"};